import React, { useState, useEffect, useCallback, useMemo, memo } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import ReactTable from "react-table";
import withFixedColumns from "react-table-hoc-fixed-columns";
import ClipboardJS from "clipboard";
import moment from "moment";
import axios from "../../axios-instance";
import { useShowActionsMenu } from "../../components/UI/ActionsMenu/hooks/useShowActionsMenu";
import { useLazyLoadOnTableScroll } from "../../hooks/useLazyLoadOnTableScroll";
// import { ApproveTransactionModal } from "./Modals/ApproveTransactionModal";
// import { EditTransactionModal } from "./Modals/EditTransactionModal";
// import { RefundTicketsModal } from "./Modals/RefundTicketsModal";
import { getHeaders } from "../../helpers/getHeaders";
import { loadFile } from "../../helpers/loadFile";
import Icon from "../../components/UI/Icon/Icon";
import { StatusLabel } from "../../components/Transactions/StatusLabel/StatusLabel";
// import { TransactionActions } from "./TransactionActions.js";
import { paymentStatuses } from "../../constants/paymentStatuses";
import CheckBox from "../../components/UI/Checkbox/CheckBox";
import NewLoader from "../../components/NewLoader/NewLoader";
import PageTitle from "../../components/UI/PageTitle/PageTitle";
import { approveOrder, clearOrders, getOrders } from '../../store/actions/OrdersActions'
import { getEventSellStats } from "../../store/actions/eventsActions";
import { getPaymentTypeLabel, paymentTypes, paymentOptions } from "../../constants/paymentType.ts";

import "react-table-hoc-fixed-columns/lib/styles.css";
import "react-table/react-table.css";
import "./OrderManagment.sass";
import { sortTypes } from "../../constants/transactions.ts";
import debounce from "lodash.debounce";
import { getCustomURLs } from "../../helpers/getCustomURLs.js";
import PleaseWaitModal from "../BarCodes/modals/PleaseWaitModal.js";

import ls from 'localstorage-slim';
import { getOrderPaymentType, orderPaymentTypeOptions } from "../../constants/orederPaymentProviders.ts";
import { IconButton } from "../../components/UI/IconButton/IconButton.js";
import { getCurrencieLabel } from "../../constants/currencies.js";
import Container from "../../components/UI/Container/Container.js";
import { ContextMenu } from "../../components/UI/ContextMenu/ContextMenu.tsx";
import { RefundProductsModal } from "./Modals/RefundProductsModal.jsx";

const MySwal = withReactContent(Swal);

const Table = memo(({
    columns,
    currentPageNumber,
    pageSize,
    transactionsList,
    handleCurrentPageChanged,
    handlePageSizeChanged,
    handleTransactionsTableScroll,
    totalTransactions
}) => {
    const ReactTableFixedColumns = withFixedColumns(ReactTable)

    return (
        <ReactTableFixedColumns
            data={transactionsList}
            columns={columns}
            manual
            showPagination={true}
            pageSizeOptions={[100, 200, 500, 1000, 100000]}
            minRows={0}
            page={currentPageNumber}
            pageSize={pageSize}
            pages={Math.ceil(totalTransactions / pageSize)}
            onPageChange={handleCurrentPageChanged}
            onPageSizeChange={handlePageSizeChanged}
            sortable={false}
            resizable={true}
            subRowsKey="products"
            getTrProps={() => ({
                style: {
                    alignItems: "stretch",
                },
            })}
            getTableProps={() => ({
                onScroll: handleTransactionsTableScroll,
            })}
        />
    )
}, () => {
    return true;
});

const OrderManagment = ({ orders, getOrders, approveOrder, clearOrders }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [requestedSearchQuery, setRequestedSearchQuery] = useState("");
    const [searchByInputNumber, setSearchByInputNumber] = useState(false);
    const [searchPaymentStatus, setSearchPaymentStatus] = useState(null);
    const [searchPaymentType, setSearchPaymentType] = useState(null);
    const [sortingType, setSortingType] = useState(sortTypes.dateDescending);
    const [isActionLoading, setActionLoading] = useState(false);

    const [currentPageNumber, setCurrentPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(100);

    const { API_URL, PUBLIC_URL, SERVER_URL } = getCustomURLs();

    const {
        ordersList,
        ordersTotal,
        ordersLoading,
        firstOrdersLoading,
    } = orders;

    const token = ls.get("user").token;

    const [showMenuActions, hideMenuActions] = useShowActionsMenu();

    const [page, handleTableScroll, resetPage] = useLazyLoadOnTableScroll(
        pageSize,
        ordersTotal);

    const handleCurrentPageChanged = (value) => {
        setCurrentPageNumber(value);
    };

    const handlePageSizeChanged = (value) => {
        setPageSize(value);
        setCurrentPageNumber(0);
    };

    const handleOrdersTableScroll = (e) => {
        handleTableScroll(e);
        hideMenuActions();
    };

    const changeSortingType = (type) => {
        resetPage();
        clearOrders();
        setSortingType(type);
    };

    const handleDebonceFn = (value) => {
        setRequestedSearchQuery(value.trim());
        setCurrentPageNumber(0);
    };

    const debounceFn = useCallback(debounce(handleDebonceFn, 1500), []);

    const changeSearchInputHandler = (e) => {
        resetPage();
        setSearchQuery(e.target.value);
        debounceFn(e.target.value);
    };

    const changeSearchByInputNumberHandler = () => {
        resetPage();
        setSearchByInputNumber(v => !v);
        setCurrentPageNumber(0);
    };

    const changeSearchPaymentStatusHandler = (item) => {
        resetPage();
        setSearchPaymentStatus(item);
        setCurrentPageNumber(0);
    };

    const changeSearchPaymentTypeHandler = (item) => {
        resetPage();
        setSearchPaymentType(item);
        setCurrentPageNumber(0);
    };

    const getPromoterOrders = (userToken) => {
        getOrders(
            userToken,
            requestedSearchQuery,
            searchByInputNumber,
            searchPaymentStatus == null ? [] : [searchPaymentStatus.value],
            null, // eventId
            "",
            currentPageNumber,
            pageSize,
            sortingType,
            !searchPaymentType ? [] : [searchPaymentType.value],
        );
    }

    useEffect(() => {
        if (token) {
            getPromoterOrders(token);
        }
    }, [
        token,
        requestedSearchQuery,
        searchPaymentStatus,
        sortingType,
        searchByInputNumber,
        currentPageNumber,
        pageSize,
        searchPaymentType,
    ]);

    const getLabelStyle = (state, rowInfo, column) => ({
        style: {
            marginTop: "6px",
        },
    });

    const getFlexStyle = () => ({
        style: {
            padding: "18px 5px 15px",
            display: "flex",
            alignItems: "start",
        },
    });

    const getStatusStyle = () => ({
        style: {
            marginTop: "3px",
            paddingTop: "20px",
            display: "flex",
            alignItems: "start",
        },
    });
    const getCorrectedTextStyle = () => ({
        style: {
            marginTop: "3px",
        },
    });

    const customSelectStyles = {
        control: (base) => ({
            ...base,
            height: "46px",
            "min-height": "46px",
            cursor: "pointer",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#ABABAB",
        }),
    };

    let emptyStateText = "There are no orders";

    if (ordersTotal === 0 && requestedSearchQuery) {
        emptyStateText = "Sorry, no results were found";
    }

    const showRefundProductsModal = (order) => {
        MySwal.fire({
            title: "Refund products",
            html:
                <RefundProductsModal
                    order={order}
                    setActionLoading={setActionLoading}
                    getOrders={getOrders}
                />,
            showConfirmButton: false,
            customClass: "refund-tickets-modal",
        });
    };

    const columns = [
        {
            Header: "Id",
            accessor: "id",
            resizable: false,
            getProps: getLabelStyle,
            width: 340,
            Cell: ({ row: { _original: { id } } }) => (
                <span title={id}>{id}</span>
            ),
        },
        {
            Header: "Email",
            accessor: "buyerEmail",
            resizable: false,
            getProps: getCorrectedTextStyle,
            width: 220,
            Cell: ({ row: { _original: { info, id } } }) => (
                <span kew={id} title={info.buyerEmail}>{info.buyerEmail}</span>
            ),
        },
        {
            Header: "Name",
            accessor: "fullName",
            resizable: false,
            getProps: getLabelStyle,
            width: 220,
            Cell: ({ row: { _original: { info } } }) => (
                <span title={info.firstName}>{info.firstName} {info.lastName}</span>
            ),
        },
        {
            Header: () => (
                <div className="payment-status" onClick={() => changeSortingType(sortingType === sortTypes.statusAscending ? sortTypes.statusDescending : sortTypes.statusAscending)}>
                    <span>Status</span>
                    <Icon name="arrow-up-down" />
                </div>
            ),
            resizable: false,
            width: 135,
            getProps: getStatusStyle,
            Cell: ({
                row: {
                    _original: {
                        info,
                        status,
                    },
                },
            }) => {
                const description =
                    status === 2
                        ? info.transactionErrorMessage
                            ? `${info.transactionErrorCode}: ${info.transactionErrorMessage}`
                            : ""
                        : "";

                return (
                    <StatusLabel statusValue={status} description={description} />
                );
            },
        },
        {
            Header: "Payment Type",
            resizable: false,
            width: 130,
            getProps: getLabelStyle,
            Cell: ({ row: { _original: { paymentType } } }) => <>{getOrderPaymentType(paymentType)}</>
        },
        {
            Header: () => {
                return <div className="payment-status" onClick={() => changeSortingType(sortingType === sortTypes.paymentDateAscending ? sortTypes.paymentDateDescending : sortTypes.paymentDateAscending)}>
                    <span>Payment Date</span>
                    <Icon name="arrow-up-down" />
                </div>

            },
            resizable: false,
            width: 180,
            getProps: getLabelStyle,
            Cell: ({ row: { _original: { paymentDate } } }) => {
                const date = new Date(paymentDate)

                if (date.getTime() < new Date(1969, 1, 1, 0, 0, 0, 0).getTime()) {
                    return <></>
                }

                return <>{
                    date.toLocaleDateString()
                } {date.toLocaleTimeString()}</>
            }
        },
        {
            width: 360,
            Header: () => {

                return <div className="rt-table subtable">
                    <div className="rt-thead -header">
                        <div className="rt-tr -odd">
                            <div className="rt-th" style={{ justifyContent: 'center' }}>Products</div>
                        </div>
                        <div className="rt-tr -odd">
                            <div className="rt-th" style={{ maxWidth: '80px' }}>Number</div>
                            <div className="rt-th" style={{ maxWidth: '140px' }}>Name</div>
                            <div className="rt-th" style={{ maxWidth: '140px' }}>Price</div>
                        </div>
                    </div>
                </div>
            },
            resizable: false,
            accessorKey: 'products',
            Cell: ({ original, toggleExpanded }) => {
                let counter = 1;
                return <div className="rt-table subtable">
                    <div className="rt-tbody">
                        {original.products.map(p =>
                            <div className="rt-tr -odd">
                                <div className="rt-td" onClick={() => toggleExpanded(true)} style={{ maxWidth: '80px' }} >{counter++}</div>
                                <div className="rt-td" style={{ maxWidth: '140px' }}>{p.productDefinition.name}</div>
                                <div className="rt-td" style={{ maxWidth: '140px' }}>{p.price} {getCurrencieLabel(p.productDefinition.currencyId)}</div>
                            </div>)}
                    </div>
                </div>
            }
        },
        {
            Header: "",
            resizable: false,
            width: 120,
            fixed: "right",
            Cell: ({ original }) => {

                return <div className="buttons-block" key={original.id}>
                    <ContextMenu key={original.id}
                        items={[
                            {
                                text: 'Refund products',
                                onClick: () => showRefundProductsModal(original)
                            }
                        ]} />

                    {
                        original.products.length > 1 && <button
                            className={'btn-primary accordion-btn'}
                            onClick={(e) => {
                                e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
                                    "active"
                                );
                                e.target.parentNode.parentNode.parentNode.classList.toggle(
                                    "active"
                                );
                            }}>
                            <Icon name={"chevron"} />
                        </button>
                    }
                </div>
            },
        },
    ];

    return (
        <Container className="order-managment">
            <PageTitle>Orders</PageTitle>

            <div className="searchPanel">
                <Select
                    isClearable
                    options={paymentStatuses}
                    placeholder="Select status"
                    name="searchPaymentStatus"
                    classNamePrefix="custom-select"
                    value={searchPaymentStatus}
                    onChange={changeSearchPaymentStatusHandler}
                    className="seasonpass__select searchPanel__select"
                    styles={customSelectStyles}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: "#6071B5",
                            primary25: "#F2F4FE",
                            primary50: "#F2F4FE",
                            primary75: "#F2F4FE",
                        },
                    })}
                />

                <Select
                    isClearable
                    options={orderPaymentTypeOptions}
                    placeholder="Select payment type"
                    name="searchPaymentType"
                    classNamePrefix="custom-select"
                    value={searchPaymentType}
                    onChange={changeSearchPaymentTypeHandler}
                    className="seasonpass__select searchPanel__select"
                    styles={customSelectStyles}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: "#6071B5",
                            primary25: "#F2F4FE",
                            primary50: "#F2F4FE",
                            primary75: "#F2F4FE",
                        },
                    })}
                />

                <input
                    className="searchPanel__search input-behavior search-icon"
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={changeSearchInputHandler}
                />

                <CheckBox checked={searchByInputNumber}
                    id='searchByInputNumber'
                    name="searchByInputNumber"
                    onChange={changeSearchByInputNumberHandler}>
                    <span className="input-behavior">
                        Search by invoice
                    </span>
                </CheckBox>

                <button
                    className='btn-primary-new admin'
                    onClick={console.log("клієнт: якийсь лох")}>
                    Download Report
                </button>
            </div>

            {(firstOrdersLoading || ordersLoading || isActionLoading) ? (
                <div className="event-transactions__loader">
                    <NewLoader />
                </div>
            ) : ordersList.length ? (
                <>
                    <Table
                        columns={columns}
                        currentPageNumber={currentPageNumber}
                        pageSize={pageSize}
                        totalTransactions={ordersTotal}
                        transactionsList={ordersList}
                        handleCurrentPageChanged={handleCurrentPageChanged}
                        handlePageSizeChanged={handlePageSizeChanged}
                        handleTransactionsTableScroll={handleOrdersTableScroll}
                    />
                </>
            ) : (
                <div className="events__empty-state">
                    <PageTitle>{emptyStateText}</PageTitle>
                    <img src="/images/img-empty-events.svg" alt="Empty transactions" />
                </div>
            )}
        </Container>
    );
}

const mapStateToProps = ({ orders }) => ({
    orders,
});

const mapDispatchToProps = (dispatch) => ({
    getOrders: (
        userToken,
        searchQuery,
        searchByInputNumber,
        paymentStatuses,
        eventId,
        orderStatus,
        page,
        pageSize,
        sortingType,
        paymentType
    ) =>
        dispatch(
            getOrders(
                userToken,
                searchQuery,
                searchByInputNumber,
                paymentStatuses,
                eventId,
                orderStatus,
                page,
                pageSize,
                sortingType,
                paymentType
            )
        ),
    approveOrder: (userToken, id, makeFiscalization, onConfirm) =>
        dispatch(approveOrder(userToken, id, makeFiscalization, onConfirm)),
    clearOrders: () => dispatch(clearOrders()),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OrderManagment)
);